import { render } from "./MseNoticeTable.vue?vue&type=template&id=67fd18a8"
import script from "./MseNoticeTable.vue?vue&type=script&lang=js"
export * from "./MseNoticeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__